import { optionsFor, resultToFailed, resultToSuccess } from '../Helper'
import stockApi, { addTokenHeader } from '../StockApi'

export const getStockLocations = async (fcId, shed, street, shelf, bin) => {
  try {
    const response = await stockApi.get('/estoque/endereco', {
      params: {
        id_fulfillment_center: fcId,
        galpao: shed,
        rua: street,
        pallete: shelf,
        escaninho: bin
      }
    })
    return resultToSuccess(response)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const updateStockAddress = async (
  barcode,
  stockBatchId,
  modelId,
  locationId,
  batchId,
  shed,
  street,
  shelf,
  bin,
  justification
) => {
  const data = {
    id_estoque_lote: stockBatchId,
    modelo_produto: modelId,
    id_localizacao: locationId,
    id_lote: batchId,
    galpao: shed,
    rua: street,
    pallete: shelf,
    escaninho: bin,
    justificativa: justification
  }
  try {
    const response = await stockApi.post(
      '/estoque/ajuste/endereco',
      data,
      optionsFor(barcode)
    )

    return resultToSuccess(response)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const getStockMovimentations = async ({
  dateFrom,
  dateTo,
  fulfillmentCenterId
}) => {
  try {
    const authHeader = await addTokenHeader()
    const response = await stockApi.get('/estoque/movimentacoes', {
      ...authHeader,
      params: {
        data: dateFrom,
        data_fim: dateTo,
        fulfillment_center_id: fulfillmentCenterId
      }
    })

    response.data = response.data.movimentacoes.map((movimentation) => ({
      collaborator: movimentation.id_usuario,
      type: movimentation.tipo,
      productCode: movimentation.id_modelo,
      description: movimentation.descricao,
      quantity: movimentation.quantidade,
      address: `${movimentation.galpao}-${movimentation.rua}-${movimentation.posicao}-${movimentation.escaninho}`,
      justification: movimentation.justificativa,
      movimentationDate: movimentation.data_movimentacao,
      expirationDate: movimentation.data_validade,
      balance: movimentation?.balance,
      fulfillmentCenter: {
        id: movimentation.fulfillment_center.id,
        name: movimentation.fulfillment_center.name
      }
    }))

    return resultToSuccess(response)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const getStockBarCode = async (barCode, fulfillment_center_id) => {
  try {
    const response = await stockApi.get(`/estoque/${barCode}`, {
      params: {
        fulfillment_center_id
      }
    })
    return resultToSuccess(response)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const updateStockProduct = async (
  addressId,
  qty,
  lotStockId,
  userBadge
) => {
  try {
    const response = await stockApi.post(
      '/estoque/abastecimento',
      {
        address_id: addressId,
        quantity: qty,
        lot_stock_id: lotStockId
      },
      {
        headers: {
          'user-barcode': userBadge
        }
      }
    )
    return resultToSuccess(response)
  } catch (e) {
    return resultToFailed(e)
  }
}

export const validateLocalization = async (
  galpao,
  rua,
  posicao,
  escaninho,
  fulfillment_center_id
) => {
  try {
    const response = await stockApi.post('estoque/localizacao/validar', {
      galpao,
      rua,
      posicao,
      escaninho,
      fulfillment_center_id
    })
    return resultToSuccess(response)
  } catch (e) {
    return resultToFailed(e)
  }
}
